import React from "react";
import Shimmer from "../../components/Shimmer";
import classes from "./filterSidebar.module.css";

const FilterSidebar = (props) => {
  return (
    <aside
      className={classes.root}
      aria-live="polite"
      aria-busy="true"
      style={{ background: "transparent" }}
    >
      <div
        style={{
          width: "275px",
          height: "564px",
          background: "transparent",
          marginBottom: "25px",
        }}
      ></div>
      {/* <Shimmer width="275px" height="564px" style={{ marginBottom: 25 }} /> */}
    </aside>
  );
};

export default FilterSidebar;
